import { WorkExperience } from "../Resume/interface"

export interface Job {
  createdBy?: string
  createdDate?: string
  updatedBy?: string
  updatedDate?: string
  id?: number
  status?: JobStatusEnum
  title: string
  specialization: string
  careerLevels: string[]
  employmentTypes: string[]
  qualifications: string[]
  skills: any
  yearsOfExp: number
  contractType: string
  minSalary: number
  maxSalary: number
  location: string
  languages: any
  responsibilities: string
  scopes: string
  area: string
  maxRetries: number
  interviewable: boolean
  description: string
  requirements: string
  tenantId?: number
}

export interface JobListing {
	id?: number
	title: string
}

export enum JobStatusEnum {
  AVAILABLE = 'AVAILABLE',
  REVIEWING = 'REVIEWING',
  TAKEN = 'TAKEN'
}

export enum JobCreateStatus {
  success = 'success',
  fail = 'fail',
  neutral = 'neutral'
}

export enum JobDeleteStatus { 
  success = 'success',
  fail = 'fail',
  neutral = 'neutral'
}

export enum JobUpdateStatus { 
  success = 'success',
  fail = 'fail',
  neutral = 'neutral'
}

export enum SetupQuestionsStatus {
  success = 'success',
  fail = 'fail',
  neutral = 'neutral'
}

export interface ResumeMatchingResult {
  resumeId: number
  fullName: string
  matchingPercentage: number
  matchedSkills: string[]
  matchedWorkExperience: WorkExperience[]
  description: string
}

export enum ResumeMatchType {
  DEFAULT = 'DEFAULT',
	INTERESTED = 'INTERESTED',
	EMPLOYED = 'EMPLOYED',
}